(() => {
  const has = (p, tag) => p.tags.includes(tag);
  const colourOf = text => {
    const s = text.toLowerCase();
    if (/pink|purple|violet|lilac|lavender|rose|blush|bean paste/.test(s)) return 'pink';
    if (/blue|silver|grey|gray/.test(s)) return 'blue';
    if (/yellow|gold|champagne/.test(s)) return 'gold';
    if (/white|ivory|cream/.test(s)) return 'ivory';
    if (/black/.test(s)) return 'dark';
    if (/olive|avocado|army|forest|moss|dark green/.test(s)) return 'deepgreen';
    if (/green|mint|sage|seafoam|celadon/.test(s)) return 'softgreen';
    return null;
  };
  const colourTags = {pink:['quiz_color_pink_purple'],blue:['quiz_color_blue_silver'],gold:['quiz_color_yellow'],ivory:['quiz_color_ivory'],dark:['quiz_color_black','quiz_color_dark'],deepgreen:['quiz_color_deepgreen'],softgreen:['quiz_color_softgreen']};
  const shapeTags = {ball:['quiz_shape_ball'],flow:['quiz_shape_flowing'],sleek:['quiz_shape_column','quiz_shape_fishtail'],mini:['quiz_shape_mini'],set:['quiz_shape_two_piece']};
  const choices = value => (Array.isArray(value) ? value : [value]).filter(v=>v && v!=='any' && v!=='Infinity');
  function rank(catalog, answers) {
    const active = ['occasion','shape','colour','detail','budget'].flatMap(key=>choices(answers[key]).map(value=>({key,value})));
    const weights={occasion:10,shape:30,colour:25,detail:20,budget:15};
    const limit=Number(answers.budget);
    const inBudget=Number.isFinite(limit)&&limit>0;
    const products=catalog.products.flatMap(p => {
      const colourIndex = p.options.findIndex(o => /color|colour/i.test(typeof o === 'string' ? o : o.name));
      const colourValues=[...new Set(p.variants.map(v=>v.options[colourIndex]).filter(Boolean))];
      const variants=p.variants.filter(v=>v.available && Number(v.price)>0 && (!inBudget||Number(v.price)<=limit*100)).flatMap(v=>{
        const colourText=globalThis.FrancieraCanonicalColours?.[String(v.id)] || (colourIndex>=0?v.options[colourIndex]:'') || '';
        const known=colourOf(colourText);
        const image=v.featured_image?.src || p.variants.find(other=>colourIndex>=0 && other.options[colourIndex]===v.options[colourIndex] && other.featured_image?.src)?.featured_image.src || (colourValues.length<=1?p.image:null);
        const matchedChoices=active.filter(({key,value})=>{
          if(key==='occasion') return has(p,'quiz_occ_'+value);
          if(key==='shape') return (shapeTags[value]||[]).some(tag=>has(p,tag));
          if(key==='colour') return known ? known===value : colourValues.length<=1 && (colourTags[value]||[]).some(tag=>has(p,tag));
          if(key==='detail') return has(p,'quiz_detail_'+value);
          return !inBudget || Number(v.price)<=limit*100;
        });
        const score=Object.keys(weights).reduce((sum,key)=>{
          const count=active.filter(c=>c.key===key).length;
          return sum+(count?weights[key]*matchedChoices.filter(c=>c.key===key).length/count:0);
        },0);
        return [{variant:{...v,featured_image:image?{src:image}:null},imageConfirmed:!!image,colourText,matchedChoices,missedChoices:active.filter(c=>!matchedChoices.includes(c)),score,total:active.length}];
      }).sort((a,b)=>b.score-a.score||Number(b.imageConfirmed)-Number(a.imageConfirmed)||a.variant.price-b.variant.price||String(a.variant.id).localeCompare(String(b.variant.id)));
      return variants.length?[{...p,...variants[0]}]:[];
    });
    return products.sort((a,b)=>b.score-a.score||a.variant.price-b.variant.price||String(a.id).localeCompare(String(b.id)));
  }
  globalThis.FrancieraQuizMatch = {rank,colourOf};
  if (typeof document === 'undefined') return;
  if(new URLSearchParams(location.search).get('flow')==='general')document.querySelectorAll('[data-bridal-quiz]').forEach(app=>{
    app.removeAttribute('data-bridal-quiz');
    const text=JSON.parse(app.querySelector('[data-quiz-text]').textContent),header=app.querySelector('[data-bridal-intro]');
    if(header){header.removeAttribute('data-bridal-intro');header.className='fvq-intro';header.replaceChildren();for(const [tag,key]of [['h1','title'],['p','intro']]){const node=document.createElement(tag);node.textContent=text[key];header.append(node);}}
  });
  document.querySelectorAll('[data-visual-quiz]:not([data-bridal-quiz])').forEach(app => {
    if (app.dataset.ready) return;
    app.dataset.ready = 'true';
    const catalog = JSON.parse(app.querySelector('[data-quiz-catalog]').textContent);
    const text = JSON.parse(app.querySelector('[data-quiz-text]').textContent);
    const decoder = document.createElement('textarea');
    Object.keys(text).forEach(key => { decoder.innerHTML = text[key]; text[key] = decoder.value; });
    const t = key => text[key] || key;
    const money = cents => new Intl.NumberFormat(catalog.locale,{style:'currency',currency:catalog.currency}).format(cents/100);
    const questions = [
      {id:'occasion',values:['bride','guest','formal','faire','portrait','any'],tags:['quiz_occ_bride','quiz_occ_guest','quiz_occ_formal','quiz_occ_faire','quiz_occ_portrait','']},
      {id:'shape',multi:true,values:['ball','flow','sleek','mini','set','any'],tags:['quiz_shape_ball','quiz_shape_flowing','quiz_shape_column','quiz_shape_mini','quiz_shape_two_piece','']},
      {id:'colour',multi:true,values:['softgreen','deepgreen','pink','blue','gold','ivory','dark','any'],tags:['quiz_color_softgreen','quiz_color_deepgreen','quiz_color_pink_purple','quiz_color_blue_silver','quiz_color_yellow','quiz_color_ivory','quiz_color_black','']},
      {id:'detail',multi:true,values:['floral','butterfly','ruffle','sparkle','draped','any'],tags:['quiz_detail_floral','quiz_detail_butterfly','quiz_detail_ruffle','quiz_detail_sparkle','quiz_detail_draped','']},
      {id:'budget',values:['100','150','200','300','Infinity']},
      {id:'timing',values:['soon','month','later','browsing']}
    ];
    if (catalog.currency !== 'GBP') {
      const prices = catalog.products.map(p => Math.min(...p.variants.filter(v => v.available).map(v => v.price / 100))).filter(Number.isFinite).sort((a,b) => a-b);
      if (prices.length) {
        const budgets = [.25,.5,.75,.95].map(q => {
          const value = prices[Math.floor((prices.length-1)*q)];
          const unit = 10 ** Math.floor(Math.log10(value)-1);
          return String(Math.ceil(value/unit)*unit);
        });
        questions.find(q => q.id === 'budget').values = [...new Set(budgets),'Infinity'];
      }
    }
    const answers = {};
    let step = 0;
    const pane = app.querySelector('[data-question]');
    const next = app.querySelector('[data-next]');
    const back = app.querySelector('[data-back]');
    const error = app.querySelector('[data-error]');
    const element = (tag,className,content) => {const e=document.createElement(tag);if(className)e.className=className;if(content!==undefined)e.textContent=content;return e;};
    const chosenPhotos = new Map();
    const usedProducts = new Set();
    const usedImages = new Set();
    const imageKey=src=>new URL(src,'https://franciera.com').pathname.split('/').pop();
    function photoFor(q,value,index) {
      if (!q.tags || value==='any' || q.id==='colour') return null;
      const key=q.id+':'+value;
      if(chosenPhotos.has(key))return chosenPhotos.get(key);
      const candidates=catalog.products.filter(p => q.id==='shape' ? (shapeTags[value]||[]).some(tag=>has(p,tag)) : has(p,q.tags[index]));
      candidates.sort((a,b)=>Number(usedProducts.has(a.id))-Number(usedProducts.has(b.id)) || String(a.id).localeCompare(String(b.id)));
      let photo=null;
      for(const p of candidates){
        const images=[p.image,...(p.images||[])].filter(Boolean);
        const src=images.find(src=>!usedImages.has(imageKey(src)));
        if(src){photo={src,title:p.title};usedProducts.add(p.id);usedImages.add(imageKey(src));break;}
      }
      chosenPhotos.set(key,photo);return photo;
    }
    function save() {try{sessionStorage.setItem('franciera_visual_quiz',JSON.stringify({version:3,answers,step}));}catch{}}
    try {
      const saved=JSON.parse(sessionStorage.getItem('franciera_visual_quiz')||'null');
      if(saved?.version===3 && saved.answers){
        questions.forEach(q=>{
          const value=saved.answers[q.id];
          if(q.multi&&Array.isArray(value)){const valid=value.filter(v=>q.values.includes(v));if(valid.length)answers[q.id]=valid.includes('any')?['any']:valid;}
          else if(!q.multi&&q.values.includes(value))answers[q.id]=value;
        });
        step=Math.min(Number(saved.step)||0,questions.length);
        const missing=questions.findIndex(q=>!answers[q.id]);
        if(missing>=0)step=Math.min(step,missing);
      }
    }catch{}
    function draw(focus=false) {
      pane.replaceChildren();error.textContent='';
      app.querySelector('[data-progress]').textContent=step===questions.length?t('results'):t('question')+' '+(step+1)+' / '+questions.length;
      app.querySelector('[data-progress-bar]').style.width=(step===questions.length?100:(step+1)/questions.length*100)+'%';
      back.hidden=step===0;next.hidden=step===questions.length;
      if(step===questions.length){results();if(focus)pane.focus();return;}
      const q=questions[step];pane.append(element('h2','',t(q.id)),element('p','fvq-sub',t(q.id+'_hint')));
      const grid=element('div','fvq-grid'+(q.id==='colour'?' fvq-grid-colour':''));grid.setAttribute('role',q.multi?'group':'radiogroup');grid.setAttribute('aria-label',t(q.id));
      q.values.forEach((value,index)=>{
        const button=element('button','fvq-option');button.type='button';button.setAttribute('role',q.multi?'checkbox':'radio');
        const selected=()=>q.multi?(answers[q.id]||[]).includes(value):answers[q.id]===value;
        button.setAttribute('aria-checked',String(selected()));
        button.tabIndex=q.multi||selected()||(!answers[q.id]&&index===0)?0:-1;
        if(value==='any')button.classList.add('fvq-option-neutral');
        const photo=photoFor(q,value,index);
        if(q.id==='colour'&&value!=='any'){
          const swatch=element('span','fvq-swatch fvq-swatch-'+value);swatch.setAttribute('aria-hidden','true');button.append(swatch);
        }
        if(photo){const img=element('img');img.src=photo.src;img.alt='';img.loading='lazy';img.width=600;img.height=800;button.append(img);}
        const copy=element('span','fvq-option-copy');
        copy.append(element('strong','',q.id==='budget'&&value!=='Infinity'?t('up_to')+' '+money(Number(value)*100):t(q.id+'_'+value)),element('small','',q.id==='budget'?t('budget_note'):t(q.id+'_'+value+'_hint')));button.append(copy);
        button.addEventListener('click',()=>{
          if(q.multi){
            const previous=answers[q.id]||[];
            answers[q.id]=value==='any'?['any']:previous.includes(value)?previous.filter(v=>v!==value):[...previous.filter(v=>v!=='any'),value];
            if(!answers[q.id].length)delete answers[q.id];
          }else answers[q.id]=value;
          grid.querySelectorAll('button').forEach((b,i)=>{
            const checked=q.multi?(answers[q.id]||[]).includes(q.values[i]):answers[q.id]===q.values[i];
            b.setAttribute('aria-checked',String(checked));b.tabIndex=q.multi||checked?0:-1;
          });
          next.disabled=!answers[q.id];error.textContent='';save();
        });
        button.addEventListener('keydown',e=>{if(['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].includes(e.key)){e.preventDefault();const delta=['ArrowRight','ArrowDown'].includes(e.key)?1:-1;const buttons=[...grid.children];const target=buttons[(index+delta+buttons.length)%buttons.length];target.focus();if(!q.multi)target.click();}});
        grid.append(button);
      });pane.append(grid);
      next.textContent=step===questions.length-1?t('show_matches'):t('next');next.disabled=!answers[q.id];
      save();if(focus)pane.focus();
    }
    function results() {
      const matches=rank(catalog,answers).slice(0,3);
      pane.append(element('h2','',t('results_title')));
      const summary=element('p','fvq-summary',t('selected')+' '+['occasion','shape','colour','detail'].map(id=>(Array.isArray(answers[id])?answers[id]:[answers[id]]).map(v=>t(id+'_'+v)).join(', ')).join(' · ')+' · '+(answers.budget==='Infinity'?t('budget_Infinity'):t('up_to')+' '+money(Number(answers.budget)*100)));pane.append(summary);
      if(!matches.length){const empty=element('div','fvq-empty');empty.append(element('h3','',t('no_matches')),element('p','',t('no_matches_hint')));const revise=element('button','fvq-action',t('adjust'));revise.type='button';revise.addEventListener('click',()=>{step=1;draw(true);});empty.append(revise);pane.append(empty);}
      else{
        pane.append(element('p','fvq-sub',t('results_hint')));
        const grid=element('div','fvq-results');matches.forEach((p,index)=>{
          const card=element('article','fvq-product');const img=element('img');if(p.imageConfirmed)img.src=p.variant.featured_image.src;img.alt=p.title;img.width=600;img.height=800;img.loading='lazy';card.append(img);
          const body=element('div','fvq-product-body');body.append(element('span','fvq-kicker',index===0?t('first_match'):t('alternative')),element('h3','',p.title),element('p','fvq-price',money(p.variant.price)));
          const label=({key,value})=>key==='budget'?t('budget_match'):t(key+'_'+value);
          const reasons=p.matchedChoices.map(label);
          body.append(element('p','fvq-score',p.total ? p.matchedChoices.length+' / '+p.total+' '+t('preferences_matched') : t('open_recommendation')));
          if(p.missedChoices.length)body.append(element('p','fvq-difference',t('differs')+' '+p.missedChoices.map(c=>c.key==='budget'?t('budget_label'):label(c)).join(', ')));
          if(p.missedChoices.some(c=>c.key==='budget'))body.append(element('p','fvq-difference',money(p.variant.price-Number(answers.budget)*100)+' '+t('over_budget')));
          body.append(element('p','fvq-reason',reasons.length?reasons.join(' · '):t('no_preferences_matched')),element('p','fvq-reason',t('option')+': '+p.variant.title));
          const link=element('a','',t('view_dress'));link.setAttribute('aria-label',t('view_dress')+': '+p.title);link.href=p.url+'?variant='+p.variant.id;body.append(link);card.append(body);grid.append(card);
        });pane.append(grid);
      }
      if(answers.timing==='soon')pane.append(element('p','fvq-note',t('soon_warning')));
      pane.append(element('p','fvq-note',t('fit_note')));
      const contact=element('a','',t('contact'));contact.href='/pages/contact';pane.append(contact);
      const revise=element('button','fvq-back',t('adjust'));revise.type='button';revise.addEventListener('click',()=>{step=0;draw(true);});pane.append(revise);save();
    }
    next.addEventListener('click',()=>{if(!answers[questions[step].id]){error.textContent=t('choose');return;}step++;draw(true);});
    back.addEventListener('click',()=>{step=Math.max(0,step-1);draw(true);});
    app.querySelector('[data-restart]').addEventListener('click',()=>{Object.keys(answers).forEach(k=>delete answers[k]);step=0;draw(true);});
    draw();
  });
})();
